import { render, staticRenderFns } from "./strukturOrganisasi.vue?vue&type=template&id=3c178ec7&"
import script from "./strukturOrganisasi.vue?vue&type=script&lang=js&"
export * from "./strukturOrganisasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QBtn,QTooltip,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCardSection,QBtn,QTooltip,QImg})
